import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ApproachSection from './components/ApproachSection';
import QualitySection from './components/QualitySection';
import ContactSection from './components/ContactSection';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'HERSA MEDIA S.R.L.',
  description: 'Professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Ap. Nr. 451 Camera 1',
    addressLocality: 'Banloc',
    postalCode: '307010',
    addressCountry: 'RO',
  },
  telephone: '+40 778129695',
  email: 'ceo@hersamedia.com',
};

export default function Home() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(organizationSchema);
    document.head.appendChild(script);

    return () => {
      const existing = document.head.querySelector('script[type="application/ld+json"]');
      if (existing) {
        document.head.removeChild(existing);
      }
    };
  }, []);

  return (
    <main>
      <HeroSection />
      <AboutSection />
      <ApproachSection />
      <QualitySection />
      <ContactSection />
    </main>
  );
}